import React, { Component, PropTypes } from 'react'
import stylesDocCss from './documents.scss'
import Modal from 'react-modal'
//import cs from 'classnames'
import nesProp from 'nested-property'
import i18n from 'lib/i18n'
// import * as c from 'state/constants'

// init translations
const _ = i18n('dswizard')
export default class IntervalInfoPopup extends Component {
    static propTypes = {
        isOpen: PropTypes.bool,
        style: PropTypes.object,
        contentLabel: PropTypes.string,
        didClose: PropTypes.func,
        modalTitle: PropTypes.string,
        modalDescription: PropTypes.string
    }

    /**
     * Content of are you sure modal
     */
    render() {
        const { style, isOpen, contentLabel, didClose, modalTitle, modalDescription } = this.props

        return (
            <Modal
                isOpen={isOpen}
                style={style}
                contentLabel={contentLabel}
            >
                <div className={stylesDocCss.documentsModalContent} key="rootComponentOfDsWizardIntervalInfoPopup">
                    <span className={stylesDocCss.title}>{modalTitle ? modalTitle : _('IntervalInfoModalTitle')}</span>
                    <div className={stylesDocCss.message}>
                        <div className={stylesDocCss.resendModalContainer}>
                            <div className={stylesDocCss.whitespacePre}>{modalDescription ? modalDescription : _('IntervalInfoModalDescription')}</div>
                        </div>
                    </div>
                    <div className={stylesDocCss.documentsModalButtons}>
                        <div
                            onClick={() => {
                                didClose()
                            }}
                            className={stylesDocCss.greenButton + " enabled"}
                        >
                            {_("ok")}
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/IntervalInfoPopup.jsx